const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      events: 'Etkinlikler',
      packages: 'Paketler',
      standings: 'Lig Durumu',
      contact: 'İletişim',
      memberLogin: 'Üye Girişi',
      adminLogin: 'Yönetim',
    },
    hero: {
      title: 'GALATASARAY GELSENKIRCHEN e.V.',
      subtitle: "Almanya'da Galatasaray Ruhu",
      joinBtn: 'Üye Ol',
      aboutBtn: 'Hakkımızda',
    },
    about: {
      title: 'Hakkımızda',
      desc: 'Galatasaray Gelsenkirchen e.V., Almanya Gelsenkirchen şehrinde yaşayan Galatasaray taraftarlarını bir araya getiren bir dernektir. Birlikte maç izleme, sosyal etkinlikler ve topluluk faaliyetleri düzenliyoruz.',
      community: 'Topluluk',
      communityDesc: "Almanya'daki Galatasaray ailesi",
      events: 'Etkinlikler',
      eventsDesc: 'Maç günleri, organizasyonlar ve daha fazlası',
      unity: 'Birlik',
      unityDesc: 'Sarı-kırmızı ruhla bir arada',
    },
    stats: {
      members: 'Üye',
      founded: 'Kuruluş Yılı',
      events: 'Etkinlik',
      family: 'Büyük Aile',
    },
    events: {
      title: 'Etkinlikler',
      detail: 'Detay',
      event1: { title: 'Maç İzleme Partisi', desc: 'Galatasaray - Fenerbahçe derbisini birlikte izleyin!', location: 'Dernek Lokali, Gelsenkirchen' },
      event2: { title: 'Yıllık Gala', desc: 'Galatasaray Gelsenkirchen ailesi olarak bir araya geliyoruz.', location: 'Stadthalle Gelsenkirchen' },
      event3: { title: 'Futbol Turnuvası', desc: 'Amatör futbol turnuvasında yerinizi alın!', location: 'Sportplatz Gelsenkirchen' },
    },
    packages: {
      badge: 'Üyelik',
      title: 'Üyelik Paketleri',
      subtitle: 'Size en uygun paketi seçin',
      pricePrefix: '',
      priceSuffix: '€',
      period: '/ay',
      oneTime: 'tek seferlik',
      selectBtn: 'Seçin',
      features: 'Özellikler',
    },
    standings: {
      title: 'Süper Lig Durumu',
      subtitle: 'Güncel puan tablosu',
      pos: 'S',
      team: 'Takım',
      played: 'O',
      won: 'G',
      drawn: 'B',
      lost: 'M',
      gf: 'AG',
      ga: 'YG',
      gd: 'AV',
      points: 'P',
    },
    cta: {
      title: 'Aramıza Katılın!',
      desc: 'Galatasaray Gelsenkirchen e.V. ailesinin bir parçası olun.',
      joinBtn: 'Hemen Üye Ol',
      loginLink: 'Zaten üye misiniz? Giriş yapın',
    },
    contact: {
      title: 'İletişim',
      address: 'Adres',
      email: 'E-posta',
      phone: 'Telefon',
      formName: 'Adınız',
      formEmail: 'E-posta',
      formMessage: 'Mesajınız',
      formSend: 'Gönder',
      formSent: 'Mesajınız gönderildi! En kısa sürede dönüş yapacağız.',
    },
    footer: {
      about: 'Galatasaray Gelsenkirchen e.V., Almanya\'da Galatasaray taraftarlarını bir araya getiren resmi dernektir.',
      quickLinks: 'Hızlı Linkler',
      contactTitle: 'İletişim',
      rights: 'Tüm hakları saklıdır.',
    },
    language: 'Sprache',
  },
  de: {
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      events: 'Veranstaltungen',
      packages: 'Pakete',
      standings: 'Tabelle',
      contact: 'Kontakt',
      memberLogin: 'Mitglieder Login',
      adminLogin: 'Verwaltung',
    },
    hero: {
      title: 'GALATASARAY GELSENKIRCHEN e.V.',
      subtitle: 'Der Galatasaray-Geist in Deutschland',
      joinBtn: 'Mitglied werden',
      aboutBtn: 'Über uns',
    },
    about: {
      title: 'Über uns',
      desc: 'Galatasaray Gelsenkirchen e.V. ist ein Verein, der Galatasaray-Fans in Gelsenkirchen, Deutschland zusammenbringt. Wir organisieren gemeinsames Public Viewing, soziale Events und Gemeinschaftsaktivitäten.',
      community: 'Gemeinschaft',
      communityDesc: 'Die Galatasaray-Familie in Deutschland',
      events: 'Veranstaltungen',
      eventsDesc: 'Spieltage, Events und vieles mehr',
      unity: 'Einheit',
      unityDesc: 'Vereint in Gelb und Rot',
    },
    stats: {
      members: 'Mitglieder',
      founded: 'Gründungsjahr',
      events: 'Veranstaltungen',
      family: 'Große Familie',
    },
    events: {
      title: 'Veranstaltungen',
      detail: 'Details',
      event1: { title: 'Public Viewing', desc: 'Erleben Sie das Galatasaray-Fenerbahçe Derby gemeinsam!', location: 'Vereinslokal, Gelsenkirchen' },
      event2: { title: 'Jahresgala', desc: 'Wir kommen als Galatasaray Gelsenkirchen Familie zusammen.', location: 'Stadthalle Gelsenkirchen' },
      event3: { title: 'Fußballturnier', desc: 'Nehmen Sie am Amateurfußballturnier teil!', location: 'Sportplatz Gelsenkirchen' },
    },
    packages: {
      badge: 'Mitgliedschaft',
      title: 'Mitgliedschaftspakete',
      subtitle: 'Wählen Sie das passende Paket',
      pricePrefix: '',
      priceSuffix: '€',
      period: '/Monat',
      oneTime: 'einmalig',
      selectBtn: 'Auswählen',
      features: 'Leistungen',
    },
    standings: {
      title: 'Süper Lig Tabelle',
      subtitle: 'Aktuelle Tabelle',
      pos: '#',
      team: 'Verein',
      played: 'Sp',
      won: 'S',
      drawn: 'U',
      lost: 'N',
      gf: 'T',
      ga: 'GT',
      gd: 'TD',
      points: 'Pkt',
    },
    cta: {
      title: 'Werden Sie Mitglied!',
      desc: 'Werden Sie Teil der Galatasaray Gelsenkirchen e.V. Familie.',
      joinBtn: 'Jetzt Mitglied werden',
      loginLink: 'Bereits Mitglied? Jetzt einloggen',
    },
    contact: {
      title: 'Kontakt',
      address: 'Adresse',
      email: 'E-Mail',
      phone: 'Telefon',
      formName: 'Ihr Name',
      formEmail: 'E-Mail',
      formMessage: 'Ihre Nachricht',
      formSend: 'Senden',
      formSent: 'Ihre Nachricht wurde gesendet! Wir werden uns in Kürze bei Ihnen melden.',
    },
    footer: {
      about: 'Galatasaray Gelsenkirchen e.V. ist der offizielle Verein, der Galatasaray-Fans in Deutschland vereint.',
      quickLinks: 'Schnelllinks',
      contactTitle: 'Kontakt',
      rights: 'Alle Rechte vorbehalten.',
    },
    language: 'Dil',
  }
};

export default translations;
